module.exports = __webpack_public_path__ + "static/media/imageUp.c1974b99.png";